import "./ColoradoMap.css";
import coloradoMap from "../../images/colorado.png";
import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";

export default function ColoradoMap() {
  const navigate = useNavigate();

  const pins = [
    { name: "Fruita", top: "39.2%", left: "14.3%", path: "/travel/usa/colorado/fruita" },
    { name: "Rifle", top: "34%", left: "25.7%", path: "/travel/usa/colorado/rifle" },
    { name: "Glenwood Springs", top: "33%", left: "32%", path: "/travel/usa/colorado/glenwoodsprings" },
    { name: "Steamboat Springs", top: "12.1%", left: "36.7%", path: "/travel/usa/colorado/steamboat" },
    { name: "Vail", top: "34%", left: "37%", path: "/travel/usa/colorado/vail" },
    { name: "Aspen", top: "42.1%", left: "37.1%", path: "/travel/usa/colorado/aspen" },
    { name: "Ouray", top: "55.1%", left: "28.8%", path: "/travel/usa/colorado/ouray" },
    { name: "Telluride", top: "65.1%", left: "17.3%", path: "/travel/usa/colorado/telluride" },
    { name: "Grand Lake", top: "18.1%", left: "49.5%", path: "/travel/usa/colorado/grandlake" },
    { name: "Frisco", top: "35.5%", left: "48.5%", path: "/travel/usa/colorado/frisco" },
    { name: "Breckenridge", top: "39%", left: "49.4%", path: "/travel/usa/colorado/breckenridge" },
    { name: "Georgetown", top: "32%", left: "52.3%", path: "/travel/usa/colorado/georgetown" },
    { name: "Idaho Springs", top: "32%", left: "55%", path: "/travel/usa/colorado/idahosprings" },
    { name: "Golden", top: "30.5%", left: "58.3%", path: "/travel/usa/colorado/golden" },
    { name: "Morrison", top: "36%", left: "59%", path: "/travel/usa/colorado/morrison" },
    { name: "Denver", top: "33.1%", left: "63.6%", path: "/travel/usa/colorado/denver" },
    { name: "Buena Vista", top: "47%", left: "55%", path: "/travel/usa/colorado/buenavista" },
    { name: "Colorado Springs", top: "49%", left: "64.5%", path: "/travel/usa/colorado/coloradosprings" },
    { name: "Manitou Springs", top: "47.5%", left: "62%", path: "/travel/usa/colorado/manitousprings" },
    { name: "Canyon City", top: "56%", left: "60%", path: "/travel/usa/colorado/canyoncity" },
    { name: "Mosca", top: "67%", left: "55%", path: "/travel/usa/colorado/mosca" },
  ];

  const cycleRef = useRef(null);
  const indexRef = useRef(0);
  const pausedRef = useRef(false);
  const timeoutRef = useRef(null);

  const [activePin, setActivePin] = useState(null);

  // ⭐ Load last index on mount
  useEffect(() => {
    const savedIndex = localStorage.getItem("coloradoMapIndex");
    if (savedIndex !== null) {
      indexRef.current = parseInt(savedIndex, 10);
    }
  }, []);

  // ⭐ Auto-cycle (desktop + mobile)
  useEffect(() => {
    const pinNodes = document.querySelectorAll(".colorado-pin");

    const startCycle = () => {
      cycleRef.current = setInterval(() => {
        if (pausedRef.current) return;

        pinNodes.forEach((p) => p.classList.remove("active"));
        pinNodes[indexRef.current].classList.add("active");

        setActivePin(indexRef.current);

        localStorage.setItem("coloradoMapIndex", indexRef.current);

        indexRef.current = (indexRef.current + 1) % pins.length;
      }, 2000);
    };

    startCycle();

    return () => clearInterval(cycleRef.current);
  }, [pins.length]);

  // ⭐ Desktop hover
  const handleHover = (index) => {
    pausedRef.current = true;
    setActivePin(index);
  };

  const handleLeave = () => {
    pausedRef.current = false;
  };

  // ⭐ Mobile touch (pause → show tooltip → resume)
  const handleTouch = (index, event) => {
    if (event && activePin !== index) {
      event.preventDefault();
    }

    pausedRef.current = true;
    setActivePin(index);

    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      pausedRef.current = false;
    }, 2000);
  };

  // ⭐ Stop cycle + navigate
  const handleNavigate = (path) => {
    pausedRef.current = true;
    clearInterval(cycleRef.current);
    navigate(path);
  };

  return (
    <div className="colorado-map-container">
      <img src={coloradoMap} alt="Colorado Map" className="colorado-map" />

      {pins.map((pin, index) => (
        <div
          key={index}
          className={`colorado-pin ${activePin === index ? "active" : ""}`}
          style={{ top: pin.top, left: pin.left }}
          onMouseEnter={() => handleHover(index)}
          onMouseLeave={handleLeave}
          onTouchStart={(e) => handleTouch(index, e)}
          onClick={() => handleNavigate(pin.path)}
        >
          <div
            className="colorado-tooltip"
            onClick={(e) => {
              e.stopPropagation();
              handleNavigate(pin.path);
            }}
            onTouchStart={(e) => {
              e.stopPropagation();
              handleNavigate(pin.path);
            }}
          >
            {pin.name}
          </div>
        </div>
      ))}
    </div>
  );
}
